import { Injectable } from '@angular/core'
import { AbstractTrackEventsService } from './abstract-track-events.service'

@Injectable()
export class TrackEventsService extends AbstractTrackEventsService {
  trackEvent(event: string, eventCategory: string, eventAction: string, eventLabel: string): void {
    window.dataLayer = window.dataLayer || []
    const payload: Record<string, unknown> = {
      event,
      eventCategory,
      eventAction,
      eventLabel,
    }
    window.dataLayer.push(payload)
  }

  trackEventUnitAdded(payload: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }

  trackEventRequestSubmitted(payload: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }

  override trackPriceRequestEvent(payload: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }
}
